<template>
  <div>
    <div class="Home">
      Contact page
    </div>
  </div>
</template>

<script>
export default {
  name: "ContactPage",
  data() {
    return {
      publicPath: process.env.VUE_APP_IMG_BASE_URL,
      products: []
    };
  }
};
</script>
